<template>
  <div>
    <AppDialog
      v-show="showDialog"
      size="smedium"
      position="centered"
      append-to-body="append-to-body"
      title="Edit shifts"
      show
      :subtitle="subtitle"
      @close="close"
    >
      <span
        v-for="option of editOptions"
        :key="option.id"
      >
        <div class="option mt-10">
          <input
            v-model="editOption"
            class="mr-10"
            type="radio"
            name="delete-option"
            :value="option.id"
          />
          {{ option.text }}
        </div>
      </span>

      <div slot="footer">
        <div class="d-flex justify-content-end">
          <AppButton
            type="default"
            class="mr-5 mt-0"
            @click.once="close"
          >
            Cancel
          </AppButton>
          <AppButton
            type="primary"
            class="mt-0"
            @click.once="edit"
          >
            Edit
          </AppButton>
        </div>
      </div>
    </AppDialog>

    <ScheduleDialog
      v-if="showEditScheduleDialog"
      id="edit-schedule-form"
      key="edit-schedule-dialog"
      editing="editing"
      :editing-attendance-schedule="editingAttendanceSchedule"
      :event="event"
      :date-range="editScheduleDateRange"
      :model-type="modelType"
      @close="close"
      @deleteShift="$emit('deleteShift')"
    ></ScheduleDialog>
  </div>
</template>

<script>
import { AttendanceSchedulesResource } from '~/resources';
import ScheduleDialog from '~/components/attendance_schedules/dialogs/ScheduleDialog.vue';

export default {
  name: 'EditAttendanceScheduleOptionsDialog',
  components: { ScheduleDialog },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAttendanceShiftDialog: false,
      editingAttendanceSchedule: null,
      editScheduleDateRange: null,
      showEditScheduleDialog: false,
      showDialog: true,
      modelType: null,
      editOption: 1,
    };
  },
  computed: {
    shift() {
      return this.event.shiftAttributes;
    },
    subtitle() {
      return moment.utc(this.event.startStr).format('ddd, MMM D, YYYY');
    },
    editOptions() {
      return [
        {
          id: 1,
          model: 'Shift',
          text: 'Only this shift',
        },
        {
          id: 2,
          model: 'Schedule',
          text: 'Selected shift and all future shifts',
        },
      ];
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async edit() {
      this.modelType = this.editOptions.find((option) => option.id === this.editOption).model;

      await AttendanceSchedulesResource.edit({
        scheduleId: this.shift.attendanceScheduleId,
      })
        .then((response) => {
          this.editingAttendanceSchedule = response;

          // Use shift minimum hours if the shift is being edited
          if (this.shift.id) {
            const [hours, minutes] = this.shift.minimumHours.split(':');

            this.editingAttendanceSchedule.minimum_hours =
              Number(hours) + Math.round((Number(minutes) / 60) * 100) / 100;
          }

          const [startDate, stopDate, startTime, stopTime] = [
            this.shift.date,
            this.shift.stop_date,
            moment.tz(this.shift.start_time, this.shift.time_zone).format('hh:mm A'),
            moment.tz(this.shift.stop_time, this.shift.time_zone).format('hh:mm A'),
          ];

          this.editScheduleDateRange = {
            start: moment(`${startDate} ${startTime}`, 'YYYY-MM-DD hh:mm A'),
            stop: moment(`${stopDate} ${stopTime}`, 'YYYY-MM-DD hh:mm A'),
          };
        })
        .finally(() => {
          this.showDialog = false;
          this.showEditScheduleDialog = true;
        });
    },
  },
};
</script>
